module.exports = __webpack_public_path__ + "img/image_7.0eb0553a.png";